import { render, staticRenderFns } from "./Peity.vue?vue&type=template&id=4cee7a6d"
import script from "./Peity.vue?vue&type=script&lang=js"
export * from "./Peity.vue?vue&type=script&lang=js"
import style0 from "./Peity.vue?vue&type=style&index=0&id=4cee7a6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports